import { z } from 'zod';
import { GroupRole } from './membership.js';
export const GroupTransferPointPolicy = z.enum(['carryover', 'none']);
export const GroupTransferRequest = z.object({
    targetGroupId: z.string().uuid(),
    userIds: z.array(z.string().uuid()).min(1).max(100),
    includeFamily: z.boolean().optional(),
    preserveArticleIds: z.array(z.string().uuid()).max(100).optional(),
    pointPolicy: GroupTransferPointPolicy.optional(),
});
export const GroupTransferMemberPreview = z.object({
    userId: z.string().uuid(),
    sourceRole: GroupRole,
    targetRole: GroupRole,
    sourceJoinedAt: z.string().datetime({ offset: true }),
    familyIncluded: z.enum(['none', 'parent', 'child']),
    targetConflict: z.boolean(),
});
export const GroupTransferPointImpact = z.object({
    sourcePoolId: z.string().uuid().nullable(),
    targetPoolId: z.string().uuid().nullable(),
    policy: GroupTransferPointPolicy,
    carryoverRequired: z.boolean(),
    heldCarryoverBlocked: z.boolean(),
    heldPointUserIds: z.array(z.string().uuid()),
    heldPointsTotal: z.number().int().nonnegative(),
});
export const GroupTransferPreviewResponse = z.object({
    sourceGroupId: z.string().uuid(),
    targetGroupId: z.string().uuid(),
    members: z.array(GroupTransferMemberPreview),
    skippedUserIds: z.array(z.string().uuid()),
    preserveArticleIds: z.array(z.string().uuid()),
    sourceLastOwnerRisk: z.boolean(),
    pointImpact: GroupTransferPointImpact,
});
export const GroupTransferResponse = GroupTransferPreviewResponse.extend({
    transferBatchId: z.string().uuid(),
    transferredCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=transfer.js.map